import { userConstants } from '../constants';

/**
 * note: cannot use selector in here instead of getState()
 * NOTE: this might be old should double check if still necessary
 * @param store
 */
const auth = (store) => (next) => (action) => {
  const { getState } = store;
  switch (action.type) {
    case userConstants.LOGIN_SUCCESS:
      const user = getState().authentication.user;
      const token = user?.token;
      if (!token) {
        throw Error(
          'something is wrong LOGIN_SUCCESS but no token found',
        );
      }
      break;
    default:
      break;
  }
  return next(action);
};

export default auth;
